import React, { Component } from "react";
import { observer } from "mobx-react";
import "./index.css";
import user from "../../../static/images/user_new.png";
import {
  getDetail,
  giveAnswer,
  editTitle,
  editAnswer,
} from "../../../static/js/http";
import { Toast } from "antd-mobile";
import { deXMLFilter } from '../../../static/js/utils'

@observer
class AnswerDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagListShow: false,
      tags: "",
      id: "",
      title: "",
      Answer: "",
      moreShow: false,
      moreShowText: "是",
      detailData: {},
    };
  }
  uncodeUtf16 = (str) => {
    var reg = /&#.*?;/g;
    var result = str.replace(reg, function (char) {
      var H, L, code;
      if (char.length === 9) {
        code = parseInt(char.match(/[0-9]+/g));
        H = Math.floor((code - 0x10000) / 0x400) + 0xd800;
        L = ((code - 0x10000) % 0x400) + 0xdc00;
        return unescape("%u" + H.toString(16) + "%u" + L.toString(16));
      } else {
        return char;
      }
    });
    return result;
  };
  utf16toEntities(str) {
    var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
    str = str.replace(patt, function (char) {
      var H, L, code;
      if (char.length === 2) {
        H = char.charCodeAt(0); // 取出高位
        L = char.charCodeAt(1); // 取出低位
        code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
        return "&#" + code + ";";
      } else {
        return char;
      }
    });
    return str;
  }
  Answer = (e) => {
    if (e.target.value.length > 500) {
      this.setState({ Answer: e.target.value.substring(0, 500) });
    } else {
      this.setState({ Answer: e.target.value });
    }
  };
  changeTitle = (e) => {
    if (e.target.value.length > 20) {
      this.setState({ title: e.target.value.substring(0, 20) });
    } else {
      this.setState({ title: e.target.value });
    }
  };
  changeTagListshow(val) {
    this.setState({ tagListShow: val });
  }
  // 选择标签
  SelsetTag(i) {
    this.setState({ tagListShow: false, tags: i });
  }
  //确定提交
  submit = () => {
    // 未回答的时候
    if (this.state.detailData.replyMany.length === 0) {
      if (!this.state.detailData.answer && !this.state.Answer) {
        Toast.info("请填写回复内容", 1);
        return;
      }
      let data = {
        answer: this.utf16toEntities(this.state.Answer),
        questionId: this.props.detailId,
        tagId: this.state.tags.id,
        isShowReply: false,
      };
      if (!this.state.Answer) {
        data.answer = this.state.detailData.answer;
      }
      Toast.loading("提交中");
      giveAnswer(data)
        .then((res) => {
          if (res.code === 200) {
            let datatitle = {
              id: this.props.detailId,
              title: this.state.title,
            };
            editTitle(datatitle).then((res) => {
              Toast.info("提交成功", 1);
              this.props.initData();
            });
          } else if (res.code === 300) {
            Toast.info("提交失败", 1);
          }
        })
        .catch((err) => {});
    } else {
      let data = {
        answer: this.state.detailData.answer,
        questionId: this.props.detailId,
        tagId: this.state.tags.id,
        isShowReply: this.state.moreShowText === "是",
        question: this.state.detailData.question,
      };
      if (this.state.detailData.replyMany.length > 0) {
        let lastData =
          this.state.detailData.replyMany[
            this.state.detailData.replyMany.length - 1
          ];
        if (lastData.type === 1) {
          // 如果最后一条是用户的回复则需要解忧人新增回复
          data.type = "add";
          data.replyNew = this.utf16toEntities(this.state.Answer);
        } else if (lastData.type === 2) {
          // 如果最后一条是解忧人的回复则是修改
          data.type = "update";
          data.replyId = lastData.id;
          data.replyNew = this.utf16toEntities(this.state.Answer);
        }
        // 如果回复为空 只改是否显示多次回复
        if (this.state.Answer === "") {
          data.type = "non";
        }
      }
      Toast.loading("提交中");
      editAnswer(data)
        .then((res) => {
          if (res.code === 200) {
            let datatitle = {
              id: this.props.detailId,
              title: this.state.title,
            };
            editTitle(datatitle).then((res) => {
              Toast.info("提交成功", 1);
              this.props.initData();
            });
          } else if (res.code === 300) {
            Toast.info("提交失败", 1);
          }
        })
        .catch((err) => {});
    }
  };
  changeMoreDesc(flag) {
    this.setState({ moreShow: flag });
  }
  SelsetMore(i) {
    this.setState({ moreShow: false, moreShowText: i });
  }
  componentDidMount() {
    getDetail({
      questionId: this.props.detailId,
    })
      .then((res) => {
        try {
          res.data.answer = deXMLFilter(res.data.answer)
          res.data.question = deXMLFilter(res.data.question)
          if(res.data.replyMany.length > 0) {
            res.data.replyMany.map(item => {
              item.reply = deXMLFilter(item.reply)
            })
          }
        } catch(e) {
          console.error('反转义失败',e)
        }
        let name = "";
        JSON.parse(sessionStorage.getItem("tags")).map((item) => {
          if (item.id === res.data.tagId) {
            name = item.name;
          }
          return item;
        });
        this.setState({
          detailData: res.data,
          tags: {
            id: res.data.tagId,
            name: name,
          },
          moreShowText: res.data.isShowReply ? "是" : "否",
          title: res.data.title ? res.data.title : "",
        });
      })
      .catch();
  }
  render() {
    let tags = JSON.parse(sessionStorage.getItem("tags"));
    return (
      <div className="AnswerDetail">
        <div className="Pdescription">{this.state.detailData.question}</div>
        {this.state.detailData.answer ? (
          <div className="answer_first">
            <div className="answer_first_item">
              <img className="user" src={this.props.groupData.icon} alt="" />
              <div className="text">
                <span>{this.props.groupData.name}</span>
                <p>{this.state.detailData.answer}</p>
              </div>
            </div>
            {this.state.detailData.replyMany &&
              this.state.detailData.replyMany.map((item, index) => (
                <div className="answer_first_item" key={index}>
                  {item.type === 1 ? (
                    <img className="user" src={user} alt="" />
                  ) : (
                    <img
                      className="user"
                      src={this.props.groupData.icon}
                      alt=""
                    />
                  )}
                  <div className="text">
                    {item.type === 2 ? (
                      <span>{this.props.groupData.name}</span>
                    ) : (
                      <span>{this.state.detailData.alias}</span>
                    )}
                    <p>{item.reply}</p>
                  </div>
                </div>
              ))}
          </div>
        ) : (
          ""
        )}
        {this.state.detailData.replyMany &&
        this.state.detailData.replyMany.length > 0 ? (
          <div className="Ptag">
            <p>是否在铺子展示多次回复 </p>
            <div
              className="Ptag_chang"
              onClick={() => {
                this.changeMoreDesc(!this.state.moreShow);
              }}
            >
              {this.state.moreShowText !== "" ? (
                <p>{this.state.moreShowText}</p>
              ) : (
                <span>请选择</span>
              )}
              <i></i>
            </div>
            {this.state.moreShow ? (
              <div className="ptag_list">
                {["是", "否"].map((i, index) => (
                  <p
                    onClick={() => {
                      this.SelsetMore(i);
                    }}
                    key={index + "Ansertags"}
                  >
                    {i}
                  </p>
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}

        <div className="Ptitle">
          <p>标题：</p>
          <div>
            <input
              type="text"
              placeholder="请输入标题"
              onChange={this.changeTitle}
              value={this.state.title}
            />

            <span>{this.state.title.length}/20</span>
          </div>
        </div>
        <div className="Ptag">
          <p>添加标签 </p>
          <div
            className="Ptag_chang"
            onClick={() => {
              this.changeTagListshow(!this.state.tagListShow);
            }}
          >
            {this.state.tags !== "" ? (
              <p>{this.state.tags.name}</p>
            ) : (
              <span>请选择</span>
            )}
            <i></i>
          </div>
          {this.state.tagListShow ? (
            <div className="ptag_list">
              {tags && tags.length !== 0
                ? tags.map((i, index) => (
                    <p
                      onClick={() => {
                        this.SelsetTag(i);
                      }}
                      key={index + "Ansertags"}
                    >
                      {i.name}
                    </p>
                  ))
                : ""}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="P_answer">
          <p>回复 {this.state.detailData.answer ? "" : <span>*</span>} :</p>
          <div>
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              placeholder="24小时内针对最新回复进行编辑"
              onChange={this.Answer}
              value={this.state.Answer}
            ></textarea>
            <span>{this.state.Answer.length}/500</span>
          </div>
        </div>
        <div
          onClick={this.submit}
          className={
            (!this.state.detailData.answer &&
              this.state.Answer !== "" &&
              this.state.tags !== "") ||
            this.state.detailData.answer
              ? "answer_subs"
              : "answer_sub"
          }
        >
          确定
        </div>
      </div>
    );
  }
}
export default AnswerDetail;
